import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from './cx.js';
/**
 * Shared card chrome for block primitives — bordered container with an
 * optional title. Kept intentionally plain; block-specific primitives own
 * their inner layout.
 */
export function BlockCard({ title, className, children, }) {
    return (_jsxs("div", { className: cx('rounded-xl border border-border bg-card p-4 text-card-foreground shadow-xs', className), children: [title ? _jsx("h3", { className: "mb-3 text-sm font-medium text-foreground", children: title }) : null, children] }));
}
